import {createAction, props} from '@ngrx/store';
import {TemplateSection, TemplateSectionType} from '@app/modules/shared/models';

enum ETemplateSectionActions {
  TemplateSectionListAll = '[TemplateSection] Template Section List All',
  TemplateSectionListAllSuccess = '[TemplateSection] Template Section List All Success',
  TemplateSectionListAllError = '[TemplateSection] Template Section List All Error',
  TemplateSectionTypeList = '[TemplateSection] Template Section Type List',
  TemplateSectionTypeListSuccess = '[TemplateSection] Template Section Type List Success',
  TemplateSectionTypeListError = '[TemplateSection] Template Section Type List Error',

  ResetTemplateSectionState = '[TemplateSection] Template Section Type List Error',
}

export const TemplateSectionListAll = createAction(ETemplateSectionActions.TemplateSectionListAll, props<{ params: any }>());
export const TemplateSectionListAllSuccess = createAction(ETemplateSectionActions.TemplateSectionListAllSuccess,
  props<{ templateSections: TemplateSection[] }>());
export const TemplateSectionListAllError = createAction(ETemplateSectionActions.TemplateSectionListAllError, props<{ error: string }>());

export const TemplateSectionTypeList = createAction(ETemplateSectionActions.TemplateSectionTypeList, props<{ params: any }>());
export const TemplateSectionTypeListSuccess = createAction(ETemplateSectionActions.TemplateSectionTypeListSuccess,
  props<{ templateSectionTypes: TemplateSectionType[] }>());
export const TemplateSectionTypeListError = createAction(ETemplateSectionActions.TemplateSectionTypeListError, props<{ error: string }>());

export const ResetTemplateSectionState = createAction(ETemplateSectionActions.ResetTemplateSectionState, (params: any = {}) => params);

